import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from '@mui/material'
import { Box, Stack } from '@mui/system'
import { useSearchParams } from 'react-router-dom';

interface Props {
  setSelectedFilter: (filter: string) => void;
}

const MonthlySummaryFilter = ({ setSelectedFilter }: Props) => {
  const [searchParams] = useSearchParams();
  const month = searchParams.get("month") as any;
  return (
    <>
      <Typography variant='h6'>{month}</Typography>
      <Stack
        flexDirection={"row"}
        justifyContent={"space-between"}
        sx={{ width: "100%" }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
          <FormLabel component="legend" sx={{ marginRight: 2 }}>Data Set:</FormLabel>
          <FormControl component="fieldset">
            <RadioGroup
              row
              aria-label="data-set"
              name="data-set"
              defaultValue="Key Metrics"
              onChange={(e) => setSelectedFilter(e.target.value)}
            >
              <FormControlLabel value="Key Metrics" control={<Radio color="secondary" />} label="Key Metrics" />
              <FormControlLabel value="Income" control={<Radio color="secondary" />} label="Income" />
              <FormControlLabel value="Performance" control={<Radio color="secondary" />} label="Performance" />
              <FormControlLabel value="All" control={<Radio color="secondary" />} label="All" />
            </RadioGroup>
          </FormControl>
        </Box>
      </Stack>
    </>
  )
}

export default MonthlySummaryFilter;
